function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "icon-checkmark_svg__b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#65D0A7"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#4DC4D6"
})), React.createElement("path", {
  id: "icon-checkmark_svg__a",
  d: "M6.831 10.12a.567.567 0 00.062-.05l4.535-4.308a.563.563 0 00-.775-.816L6.468 8.922 4.747 7.11a.562.562 0 10-.816.775l2.105 2.216c.214.225.57.234.795.02zM7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1-1h18v18H-1z"
}), React.createElement("g", {
  transform: "translate(.5 .5)"
}, React.createElement("mask", {
  id: "icon-checkmark_svg__c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#icon-checkmark_svg__a"
})), React.createElement("g", {
  fill: "url(#icon-checkmark_svg__b)",
  mask: "url(#icon-checkmark_svg__c)"
}, React.createElement("path", {
  d: "M-1.5-1.5h17.798v17.798H-1.5z"
}))));

var SvgIconCheckmark = function SvgIconCheckmark(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-checkmark.54e25737.svg";
export { SvgIconCheckmark as ReactComponent };